import { useEffect } from 'react';

import { isEmpty } from '@groww-tech-pvt/ella';

import { setUserAttributesAtHoist } from 'src/utils/adapter/hoist';
import { setUserContext } from 'src/utils/adapter/gobbler';
import { useUserDataStore, type UserDataV2 } from 'src/utils/store/UserData';

/**
 * Mirrors desktop `InjectUserData`: keeps Gobbler user context and Hoist user
 * attributes in sync when the onboarding user store hydrates / updates.
 */
export const InjectUserData = () => {
  const { userData } = useUserDataStore();
  const { user_account_id, email_id, first_name } = (userData as UserDataV2) || {};

  useEffect(() => {
    try {
      if (!isEmpty(userData)) {
        setUserContext({
          emailId: email_id ?? '',
          userAccountId: user_account_id ?? '',
          userName: first_name ?? '',
        });

        setTimeout(() => {
          setUserAttributesAtHoist({
            userId: user_account_id ?? '',
          });
        }, 500);
      }
    } catch (error) {
      console.error(error);
    }
  }, [user_account_id, email_id, first_name]);

  return null;
};
